import type { BrowserInfo } from "@Common/types/bo/analytics_public/analytics_public";
import { collectBrowserInfo } from "@Src/utils/collectBrowserInfo";
import { createContext, type ReactNode, useContext, useMemo } from "react";

type BrowserInfoContextValue = {
	browserInfo: BrowserInfo;
};

const BrowserInfoContext = createContext<BrowserInfoContextValue | undefined>(
	undefined,
);

export const BrowserInfoProvider = ({ children }: { children: ReactNode }) => {
	const browserInfo = useMemo(() => collectBrowserInfo(), []);
	return (
		<BrowserInfoContext.Provider value={{ browserInfo }}>
			{children}
		</BrowserInfoContext.Provider>
	);
};

export const useBrowserInfo = () => {
	const ctx = useContext(BrowserInfoContext);
	if (!ctx)
		throw new Error("useBrowserInfo must be used inside BrowserInfoProvider");
	return ctx;
};
